// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"FivaFooter_linkContainer__8DQkY","policy":"FivaFooter_policy__woqYS","container":"FivaFooter_container__O3WvG"};